/**
 * Display the current count of elements in a list
 * @see https://developers.getswym.com/docs/fetch-lists
 */
class WishlistCount extends HTMLElement {
	constructor() {
		super();
		this.swat = undefined;
		this.listName = undefined;
		this.count = undefined;
	}

	connectedCallback() {
		this.setAttribute("data-state", "loading");
		this.listName = this.getAttribute("list-name");
		this.registerSwat();
	}

	registerSwat() {
		if (!window.SwymCallbacks) {
			window.SwymCallbacks = [];
		}
		window.SwymCallbacks.push((swat) => {
			this.swat = swat;
			this.init();
		});
	}

	init() {
		this.swat.fetchLists({
			callbackFn: (data) => {
				const selectedList = data.find((list) => list.lname === this.listName);
				if (selectedList === undefined) {
					this.setAttribute("data-state", "error");
					return;
				}
				this.count = selectedList.cnt;
				this.listenToUpdate();
				this.render();
			},
			errorFn: () => {
				this.setAttribute("data-state", "error");
			},
		});
	}

	listenToUpdate() {
		this.swat.evtLayer.addEventListener("sw:addedtowishlist", () => {
			this.count += 1;
			console.log("test - added");
			this.render();
		});
		this.swat.evtLayer.addEventListener("sw:removedfromwishlist", () => {
			this.count -= 1;
			console.log("test - removed");
			this.render();
		});
	}

	render() {
		console.log("test - rendering", this.count);
		this.setAttribute("data-state", "visible");
		if (this.count > 99) {
			this.innerText = `${99}+`;
		} else {
			this.innerText = Math.max(this.count, 0);
		}
	}
}

customElements.define("wishlist-count", WishlistCount);
